module.exports = __webpack_public_path__ + "img/racecourse-kenilworth-turf-summer-2200.4c05030a.svg";